/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
/**
 *
 * @export
 * @interface RegistryDates
 */
export interface RegistryDates {
  /**
   *
   * @type {Date}
   * @memberof RegistryDates
   */
  applicationDate: Date
  /**
   *
   * @type {Date}
   * @memberof RegistryDates
   */
  registrationDate?: Date
  /**
   *
   * @type {Date}
   * @memberof RegistryDates
   */
  publicationDate?: Date
  /**
   *
   * @type {Date}
   * @memberof RegistryDates
   */
  expiryDate?: Date
  /**
   *
   * @type {Date}
   * @memberof RegistryDates
   */
  priorityDate?: Date
}

/**
 * Check if a given object implements the RegistryDates interface.
 */
export function instanceOfRegistryDates(value: object): value is RegistryDates {
  if (!('applicationDate' in value) || value['applicationDate'] === undefined)
    return false
  return true
}

export function RegistryDatesFromJSON(json: any): RegistryDates {
  return RegistryDatesFromJSONTyped(json, false)
}

export function RegistryDatesFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): RegistryDates {
  if (json == null) {
    return json
  }
  return {
    applicationDate: new Date(json['applicationDate']),
    registrationDate:
      json['registrationDate'] == null
        ? undefined
        : new Date(json['registrationDate']),
    publicationDate:
      json['publicationDate'] == null
        ? undefined
        : new Date(json['publicationDate']),
    expiryDate:
      json['expiryDate'] == null ? undefined : new Date(json['expiryDate']),
    priorityDate:
      json['priorityDate'] == null ? undefined : new Date(json['priorityDate']),
  }
}

export function RegistryDatesToJSON(value?: RegistryDates | null): any {
  if (value == null) {
    return value
  }
  return {
    applicationDate: value['applicationDate'].toISOString(),
    registrationDate:
      value['registrationDate'] == null
        ? undefined
        : value['registrationDate'].toISOString(),
    publicationDate:
      value['publicationDate'] == null
        ? undefined
        : value['publicationDate'].toISOString(),
    expiryDate:
      value['expiryDate'] == null
        ? undefined
        : value['expiryDate'].toISOString(),
    priorityDate:
      value['priorityDate'] == null
        ? undefined
        : value['priorityDate'].toISOString(),
  }
}
